export default "dist/images/block-blog-posts-list.b2a5696.png";